import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Icon from "@material-ui/icons/NetworkCheck";

import Button from "components/CustomButtons/Button.jsx";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import { appConstants } from "../../_constants";

class NotFound extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    return (
      <div>
        <GridContainer>
            <GridItem xs={12}>
                  <Card>
                      <CardHeader color="success" stats icon>
                          <CardIcon color="success">
                              <Icon />
                          </CardIcon>
                      </CardHeader>
                      <CardBody style={{textAlign: 'center', paddingTop: 0}}>
                          <h1 style={{textAlign: 'center', margin: 0, fontSize: '65px'}}>
                              4
                              <span style={{fontSize: '80px', color: appConstants.DANGER_COLOR}}>0</span>
                              4
                          </h1>
                          <h4 style={{margin: '0 0 15px'}}>
                              Oops! We can't seem to find the page you're looking for.
                          </h4>
                          <Link to={'/landing'}>
                              <Button
                                  type="button"
                                  color="primary"
                              >
                                  Go to Homepage
                              </Button>
                          </Link>
                      </CardBody>
                  </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
    const { user} = state;
    return {
        user,
    };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(NotFound)));



// WEBPACK FOOTER //
// ./src/Regional-Views/NotFound/Index.jsx